<div class="BagsBenefitErrorModal">
  <div class="BagsBenefitErrorModal-close">
    <img alt="cerrar" src="../../../../assets/images/close.svg" (click)="onCancel()" />
  </div>

  <div class="BagsBenefitErrorModal-container text-center">
    <img
      alt="error"
      class="BagsBenefitErrorModal-logo"
      src="../../../../assets/images/cobrand/bags-benefit-error.svg"
    />

    <p class="BagsBenefitErrorModal-title fs-36px lh-52px fw-medium-x">
      {{ 'bagsBenefitErrorModal.title' | translate }}
    </p>

    <p class="BagsBenefitErrorModal-description fs-20px lh-34px fw-regular">
      {{ 'bagsBenefitErrorModal.description' | translate : { bankName: bankNameKey | translate } }}
    </p>

    <div class="BagsBenefitErrorModal-buttons">
      <button class="BagsBenefitErrorModal-btnCancel" (click)="onCancel()">
        {{ 'bagsBenefitErrorModal.cancel' | translate }}
      </button>
      <button class="BagsBenefitErrorModal-btnRetry" (click)="onRetry()">
        <img
          class="BagsBenefitErrorModal-retryIcon"
          src="../../../../assets/images/Reload_Search.svg"
          alt=""
        />
        {{ 'bagsBenefitErrorModal.retry' | translate }}
      </button>
    </div>
  </div>
</div>
